import React from "react";
import BoxLoader from "../../../../general/boxLoader";
import EmptyBox from "../../../../general/emptyBox";
import PatientBiometricCardsBoxItem from "./patientBiometricCardsBox_Item";

type PatientBiometricsCardsBoxProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean;
  readonly?: boolean;
}

const PatientBiometricCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting,
  readonly = false
}: PatientBiometricsCardsBoxProps) => {
  const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
    return <PatientBiometricCardsBoxItem item={item} dataListTitles={dataListTitles} key={i} readonly={readonly}/>
  })
  return (
    <div>
      {isRequesting ? <BoxLoader/> : _dataList ? _dataList : <EmptyBox content={''} className={''} children={''}/>}
    </div>
  )
}

export default PatientBiometricCardsBox;